module.exports = __webpack_public_path__ + "img/vue2-corpsarr_rose.5cdeca61.png";